import './KycForm.less';
import React from 'react';
import KycQuestion from './KycQuestion';

function KycForm({ form, questionList }) {
    return (
        <div className="kyc-form">
            <div className="kyc-form-list">
                {questionList.map((question, index) => (
                    <KycQuestion key={index} form={form} question={question} />
                ))}
            </div>
        </div>
    );
}

export default KycForm;
